import React, { useEffect, useState } from 'react';

const MusicButton = () => {
  const [enabled, setEnabled] = useState(
    () => localStorage.getItem('backgroundMusic') !== 'off'
  );

  useEffect(() => {
    const handleMusicChange = () => {
      setEnabled(localStorage.getItem('backgroundMusic') !== 'off');
    };

    window.addEventListener('backgroundMusicChanged', handleMusicChange);

    return () => {
      window.removeEventListener(
        'backgroundMusicChanged',
        handleMusicChange
      );
    };
  }, []);

  const toggleMusic = () => {
    window.dispatchEvent(new Event('toggleBackgroundMusic'));
  };

  return (
    <button
      type="button"
      onClick={toggleMusic}
      aria-label={
        enabled
          ? 'Turn background music off'
          : 'Turn background music on'
      }
      title={enabled ? 'Turn music off' : 'Turn music on'}
      className="
        flex
        shrink-0
        items-center
        justify-center
        w-7
        h-7
        p-0
        rounded-full
        border
        border-cyan-200/30
        bg-slate-900/70
        text-white
        backdrop-blur-md
        shadow-lg
        shadow-cyan-500/20
        hover:border-cyan-200/60
        hover:bg-slate-800/80
        hover:scale-105
        active:scale-95
        transition-all
        duration-300
      "
      data-testid="music-toggle-button"
    >
      <span
        aria-hidden="true"
        className="block leading-none"
        style={{ fontSize: '13px', lineHeight: 1 }}
      >
        {enabled ? '🔊' : '🔇'}
      </span>
    </button>
  );
};

export default MusicButton;
